// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckList_wrapper__51CyZ","passed":"CheckList_passed__KmHIU","notpassed":"CheckList_notpassed__1uUCc"};